<template>
    <div class="confirmation-dialog">
        <v-modal :show="show" :headerVisible="false" :size="'m'">
            <template v-slot:title>
                <p style="height:40px;"></p>
            </template>
            <template v-slot:body>
                <div class="notifit_confirm_message">
                    <div class="general-nofi-modal-title">
                        {{message}}
                    </div>
                    <div class="general-nofi-modal-msg">
                        {{additionalMessage}}
                    </div>
                    <div v-if="note" class="general-nofi-modal-msg margin-top-10">
                        {{note}}
                    </div>
                </div>
            </template>
            <template v-slot:buttons>
                <p style="text-align:center;">
                    <button class="btn btn-success btn-confirmation" @click.prevent="yesClicked">YES</button>
                    <button class="btn btn-primary btn-confirmation" @click.prevent="cancelClicked">NO</button>
                </p>
            </template>
        </v-modal>
    </div>
</template>

<script>

    export default {
        name: "confirmation-dialog",
        components: {

        },
        props: {
            title: String,
            message: String,
            additionalMessage: String,
            show: Boolean,
            note: String
        },
        methods: {
            yesClicked() {
                this.$emit("yes");
            },
            cancelClicked() {
                this.$emit("cancel");
            }
        },
        created() {
            this.$eventBus.$on("v-modal-close", () => this.cancelClicked());
        },
        beforeDestroy() {
            this.$eventBus.$off("v-modal-close");
        }
    };
</script>

<style>
    .confirmation-dialog .modal-dialog {
        top: 25% !important;
    }

    .btn-confirmation {
        width: 85px;
    }

    .general-nofi-modal-msg {
        margin-top: 25px;
        margin-bottom: -3px;
    }
</style>


// WEBPACK FOOTER //
// confirmation-dialog.vue?a916f36a